<mat-card class="card" *ngIf="show">
    <mat-card-title>
        <div style="margin-left: 41%; margin-top: 10%;"><h4>PAYMENT IN PROGRESS</h4></div>
        <div style="margin-left: 43%;"><h5>Do not navigate away from</h5></div>
        <div style="margin-left: 44%;"><h5>this page until complete!</h5></div>
    </mat-card-title>
    <mat-card-content>
        <div style="margin-top: 3%; margin-left: 40%;">
            <mat-progress-spinner [diameter]="300" color="warn" mode="indeterminate"></mat-progress-spinner>
        </div>
    </mat-card-content>
</mat-card>

